/**
 * Adds +34 to the beginning of the phone number if a country code is not typed
 */
import React from 'react'

import TextInput from './TextInput'

const DEFAULT_COUNTRY_CODE = '+34'
interface PhoneInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  phoneCountryValue?: string,
  phoneValue?: string
}
const PhoneInput: React.FC<PhoneInputProps> = ({ onChange, phoneCountryValue, phoneValue, ...rest }) => {
  React.useEffect(() => {
    onChange({ target: { name: 'phoneCountryCode', value: phoneCountryValue ?? DEFAULT_COUNTRY_CODE } } as React.ChangeEvent<HTMLInputElement>)
  }, [])

  const doNothingOnWheel = (e: React.WheelEvent<HTMLInputElement>) => {
    e.preventDefault()
    e.currentTarget.blur()
  }

  return (
    <div className='w-full flex gap-x-3'>
      <div>
        <TextInput className='w-20 inline-block' name='phoneCountryCode' type='text' onChange={onChange} defaultValue={phoneCountryValue || DEFAULT_COUNTRY_CODE} />
      </div>
      <div className='w-full'>
        <TextInput name='phone' type='number' onChange={onChange} defaultValue={phoneValue} {...rest} className='w-full inline-block' onWheel={doNothingOnWheel} />
      </div>
    </div>
  )
}

export default PhoneInput
